import { FC, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useLayout } from '../../../core/LayoutProvider'
import { usePageData } from '../../../core/PageData'
import { Check, ChevronDown, ChevronUp, CircleSmall, Target } from 'lucide-react'
import ThemeTooltip from '../../../../../app/modules/apps/components/UI/ThemeTooltip'
type Props = {
  textStyle?: string;
  hideTitle?: boolean;
}
const DefaultTitle: FC<Props> = ({ textStyle = "dark", hideTitle = false }) => {
  const { pageTitle, pageDescription, pageBreadcrumbs } = usePageData()
  const { config, attributes } = useLayout()
  const isDark = textStyle === 'dark';
  return (
    <div {...attributes.pageTitle} className='page-title d-flex flex-column'>
      {/* begin::Title */}
      {!hideTitle && pageTitle && (
        <h1 className={`d-flex ${isDark ? 'text-gray-800' : 'text-white'} fw-semibold my-1 fs-3`}>
          {pageTitle}
        </h1>
      )}
      {/* end::Title */}
      {pageDescription && (
        <>
          <div className={`${isDark ? 'text-gray-800' : 'text-white'} fs-7 fw-semibold my-1`}>{pageDescription}</div>
        </>
      )}
      {pageBreadcrumbs &&
        pageBreadcrumbs.length > 0 &&
        config.pageTitle &&
        config.pageTitle.breadCrumbs && (
          <ul className='breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1'>
            {Array.from(pageBreadcrumbs).map((item, index) => (
              <li className={`breadcrumb-item ${isDark ? 'text-gray-800' : 'text-white'} opacity-75`} key={`${item.path}${index}`}>
                {!item.isSeparator ? item.path ? (
                  <Link className={`${isDark ? 'text-gray-800' : 'text-white'} text-hover-primary`} to={item.path} state={item.state}>
                    {item.title}
                  </Link>
                ) : <span className={`${isDark ? 'text-gray-800' : 'text-white'}`}>{item.title}</span> : (
                  <span className={`bullet ${isDark ? 'bg-gray-800' : 'bg-white'} opacity-75 w-5px h-2px`}></span>
                )}
              </li>
            ))}
          </ul>
        )}
    </div>
  )
}


type TitleProps = {
  textStyle?: string;
  hideTitle?: boolean;
}
const items=[
  "NT Infrastructure Planning Framework (BFI 2026)",
  "Infrastructure Fiscal Sustainability Assessment (IFISA)",
  "Cost-Benefit Analysis (CBA) / Cost-Effectiveness Analysis (CEA)",
  "ISO 9001 Quality Management System (final validation gate)",
]
const DefaultTitleWithBreadcrumbs: FC<TitleProps> = ({ textStyle = "dark", hideTitle = false }) => {
  const { pageTitle, pageDescription, purpose, completionGuide, subTitle, subText, subDescription } = usePageData();
  const [isOpen, setIsOpen] = useState(false);
  const handleOpen = () => {
    setIsOpen(!isOpen);
  }
  const { attributes } = useLayout()
  const isDark = textStyle === 'dark';
  return (
    <div {...attributes.pageTitle} className='page-title d-flex flex-column flex-grow-1'>
      {/* begin::Description */}
      {pageDescription && (
        <div className={`${isDark ? 'text-gray-800' : 'text-white'} fs-7 fw-semibold my-1`}>{pageDescription}</div>
      )}
      {/* end::Description */}
      {/* begin::Title */}
      <div className="border border-info bg-light-info rounded-4 p-3 mt-1 position-relative">
        {!hideTitle && pageTitle && (
          <h1 className={`d-flex ${isDark ? 'text-black' : 'text-white'} fw-bold mb-2 m-0 fs-3 gap-2`}>
            {pageTitle} {subTitle && <span className='fw-normal'> - {subTitle}</span>} {completionGuide && <ThemeTooltip text={completionGuide} theme="dark" />}
          </h1>
        )}
        {purpose && <p className="fw-bold mb-0"><Target size={16} className="me-2" /> Purpose - <span className='fw-normal'>{purpose}</span></p>}
        {subText && <div className="fw-normal" dangerouslySetInnerHTML={{ __html: subText }}></div>}
        {subDescription?.title && <button type='button' className='btn btn-sm p-2 btn-accordion-subtext' onClick={handleOpen}><ThemeTooltip trigger="click" text={subDescription?.title} theme="dark" typeTooltip="default" Wrapper={isOpen ? <ChevronUp size={16} className='text-white' /> : <ChevronDown size={16} />} /></button>}
        {isOpen && <div className="accordion-subtext-content mt-3 bg-info rounded-2 p-3 text-white">
          <p className='fw-bold text-uppercase fs-7 mb-1'>{subDescription?.title}</p>
          <p className='fs-7 mb-1'>{subDescription?.description}</p>
          <div className='d-flex flex-wrap gap-x-6 gap-y-1'>
            {subDescription?.items.map((item, index) => (
              <div key={index} className='d-flex items-center fs-7 me-6'>
                <CircleSmall size={16} className="me-2" />{item}
              </div>
            ))}
          </div>
        </div>}
      </div>
      {/* end::Title */}

    </div>
  )
}

export { DefaultTitle, DefaultTitleWithBreadcrumbs }
